<template>
    <v-sheet
      class="dropzone d-flex flex-column align-center justify-center text-center"
      @dragover.prevent="isDragging = true"
      @dragleave.prevent="isDragging = false"
      @drop.prevent="handleDrop"
      @click="triggerInput"
      :class="{ 'dropzone--active': isDragging }"
    >
      <v-icon size="36" color="grey">mdi-cloud-upload</v-icon>
      <div class="mt-2 font-weight-medium">{{ label }}</div>
  
      <div class="my-1 d-flex align-center">
        <div class="mx-2" style="flex: 1; height: 1px; background: #ccc;"></div>
        <div class="text-caption text-grey">sau</div>
        <div class="mx-2" style="flex: 1; height: 1px; background: #ccc;"></div>
      </div>
  
      <v-btn size="small" variant="outlined" color="primary">Alege fișiere</v-btn>
  
      <input
        ref="fileInput"
        type="file"
        class="d-none"
        :accept="accept"
        :multiple="multiple"
        @change="handleSelect"
      />
    </v-sheet>
  
    <v-list v-if="internalFiles.length" class="mt-2" density="compact">
      <v-list-item
        v-for="(file, i) in internalFiles"
        :key="i"
        :title="file.name"
        :subtitle="`${(file.size / 1024).toFixed(2)} KB`"
      >
        <template #append>
          <v-btn icon size="x-small" variant="text" @click.stop="removeFile(i)">
            <v-icon size="18">mdi-close</v-icon>
          </v-btn>
        </template>
      </v-list-item>
    </v-list>
  </template>
  
  <script>
  export default {
    name: "DropZoneUploader",
    props: {
      /**
       * Accept file types (.pdf, .xls etc)
       */
      accept: {
        type: String,
        default: "*/*",
      },
      /**
       * Allow multiple file uploads
       */
      multiple: {
        type: Boolean,
        default: true,
      },
      /**
       * Label displayed above
       */
      label: {
        type: String,
        default: "Trage fișiere aici",
      },
      /**
       * v-model: bound file list
       */
      modelValue: {
        type: Array,
        default: () => [],
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        isDragging: false,
        internalFiles: [],
      };
    },
    watch: {
      modelValue: {
        handler(val) {
          this.internalFiles = [...val];
        },
        immediate: true,
      },
    },
    methods: {
      triggerInput() {
        this.$refs.fileInput?.click();
      },
      handleDrop(e) {
        this.isDragging = false;
        const files = Array.from(e.dataTransfer.files);
        this.addFiles(files);
      },
      handleSelect(e) {
        const files = Array.from(e.target.files);
        this.addFiles(files);
        e.target.value = "";
      },
      addFiles(files) {
        const acceptedExtensions = this.accept
          .split(",")
          .map((ext) => ext.trim().toLowerCase());
  
        const filtered = acceptedExtensions.includes("*/*")
          ? files
          : files.filter((f) =>
              acceptedExtensions.some((ext) => f.name.toLowerCase().endsWith(ext))
            );
  
        this.internalFiles.push(...filtered);
        this.$emit("update:modelValue", this.internalFiles);
      },
      removeFile(index) {
        this.internalFiles.splice(index, 1);
        this.$emit("update:modelValue", this.internalFiles);
      },
    },
  };
  </script>
  
  <style scoped>
  .dropzone {
    border: 2px dashed #40bfb4;
    border-radius: 8px;
    padding: 24px;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
    background-color: #f9f9f9;
  }
  
  .dropzone--active {
    background-color: #e0f7f4;
    border-color: #2d807c;
  }
  </style>
  